import { Button, Card, Col, Form, Input, Row, Select, Table } from 'antd'
import { InwardFilterReq } from 'libs/shared-models/raw-material-procurement/src/lib/raw-material-grn/inward-filter-req'
import { RMGrnService } from 'libs/shared-services/raw-material-procurement/src/lib/grn-raw-material.service'
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import Highlighter from 'react-highlight-words';
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { ColumnProps } from 'antd/lib/table'
import { Excel } from 'antd-table-saveas-excel'
import moment from 'moment'

const InwardReport = () => {
    const [inwardData, setInwardData] = useState<any>([])
    const [inwardNo,setInwardNo]=useState<any>(null)
    const [supplierData,setSupplierData]=useState<any>([])
    const [productsData,setProductsData]=useState<any>([])
    const [inwardType,setInwardType]=useState<any>([])
    const [voucherNo,setVoucherNo]=useState<any>(null)
    const rmProcureService=new RMGrnService()
    const [form] = Form.useForm()
    const { Option } = Select
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    useEffect(()=>{
        getInwardReport()
        getInwardNo()
        getInwardType()
        getInwardFarmers()
        getInwardProducts()
        getInwardVouchers()
    },[])
    
    const getInwardReport=()=>{
        const req=new InwardFilterReq()
        req.inwardId=form.getFieldValue('inwardNo')
        req.inwardType=form.getFieldValue('inwardType')
        req.supplierId=form.getFieldValue('supplierId')
        req.productId=form.getFieldValue('productId')
        req.voucherNo=form.getFieldValue('voucherNo')
     rmProcureService.getInwardReport(req).then((res)=>{
        if(res.status){
            setInwardData(res.data)
        }else{
            setInwardData([])
        }
        })
    }

        const getInwardNo=()=>{
     rmProcureService.getInwardNo().then((res)=>{
        if(res.status){
            setInwardNo(res.data)
        }else{
            setInwardNo([])
        }
        })
    }

        const getInwardType=()=>{
     rmProcureService.getInwardType().then((res)=>{
        if(res.status){
            setInwardType(res.data)
        }else{
            setInwardType([])
        }
        })
    }

        const getInwardFarmers=()=>{
     rmProcureService.getInwardFarmers().then((res)=>{
        if(res.status){
            setSupplierData(res.data)
        }else{
            setSupplierData([])
        }
        })
    }

        const getInwardProducts=()=>{
     rmProcureService.getInwardProducts().then((res)=>{
        if(res.status){
            setProductsData(res.data)
        }else{
            setProductsData([])
        }
        })
    }

        const getInwardVouchers=()=>{
     rmProcureService.getInwardVouchers().then((res)=>{
        if(res.status){
            setVoucherNo(res.data)
        }else{
            setVoucherNo([])
        }
        })
    }

              function handleSearch(selectedKeys, confirm, dataIndex) {
            confirm();
            setSearchText(selectedKeys[0]);
            setSearchedColumn(dataIndex);
        };
        function handleReset(clearFilters) {
            clearFilters();
            setSearchText('');
        };
        const getColumnSearchProps = (dataIndex: string) => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={searchInput}
                        placeholder={`Search ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            onFilter: (value, record) =>
                record[dataIndex]
                    ? record[dataIndex]
                        .toString()
                        .toLowerCase()
                        .includes(value.toLowerCase())
                    : false,
            onFilterDropdownVisibleChange: visible => {
                if (visible) { setTimeout(() => searchInput.current.select()); }
            },
            render: text =>
                text ? (
                    searchedColumn === dataIndex ? (
                        <Highlighter
                            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                            searchWords={[searchText]}
                            autoEscape
                            textToHighlight={text.toString()}
                        />
                    ) : text
                ) : null
        });

    const Columns: ColumnProps<any>[]  = [
        {
            title: "S.No",
            render: (_: any, __: any, index: number) => index + 1
        },
        {
            title: "Inward Code",
            dataIndex: "inwardCode",
            key: "inwardCode",
            ...getColumnSearchProps('inwardCode'),
            sorter: (a, b) => a.inwardCode.localeCompare(b.inwardCode),
            sortDirections: ['descend', 'ascend'],
             render: (text) => text ? text : '-',
        },
        {
            title: "Inward Date",
            dataIndex: "inwardDate",
            key: "inwardDate",
                ...getColumnSearchProps('inwardDate'),
            sorter: (a, b) => new Date(a.inwardDate).getTime() - new Date(b.inwardDate).getTime(),
            sortDirections: ['descend', 'ascend'],
                        render: (text) =>text ? new Date(text).toLocaleDateString('en-GB') : '-',

        },
        {
            title: "Indent Status",
            dataIndex: "indent_status",
            key: "indent_status",
                ...getColumnSearchProps('indent_status'),
            sorter: (a, b) => a.indent_status.localeCompare(b.indent_status),
            sortDirections: ['descend', 'ascend'],
             render: (text) => text ? text : '-',
        },
        {
            title: "Inward Type",
            dataIndex: "inwardType",
            key: "inwardType",
                ...getColumnSearchProps('inwardType'),
            sorter: (a, b) => a.inwardType.localeCompare(b.inwardType),
            sortDirections: ['descend', 'ascend'],
             render: (text) => text ? text : '-',
        },
                {
            title: "Voucher No",
            dataIndex: "voucherNo",
            key: "voucherNo",
            ...getColumnSearchProps('voucherNo'),
            sorter: (a, b) => a.voucherNo.localeCompare(b.voucherNo),
            sortDirections: ['descend', 'ascend'],
             render: (text) => text ? text : '-',
        },
        {
            title: "Voucher Date",
            dataIndex: "voucharDate",
            key: "voucharDate",
            sorter: (a, b) => new Date(a.voucharDate).getTime() - new Date(b.voucharDate).getTime(),
            sortDirections: ['descend', 'ascend'],
            ...getColumnSearchProps('voucharDate'),
            render: (text) =>text ? new Date(text).toLocaleDateString('en-GB') : '-',
        },
        {
            title: "Farmer",
            dataIndex: "supplierName",
            key: "supplierName",
            ...getColumnSearchProps('supplierName'),
            sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
            sortDirections: ['descend', 'ascend'],
             render: (text) => text ? text : '-',
        },
        {
            title: "Product",
            dataIndex: "productName",
            key: "productName",
            ...getColumnSearchProps('productName')  ,
            sorter: (a, b) => a.productName.localeCompare(b.productName),
            sortDirections: ['descend', 'ascend'],
             render: (text) => text ? text : '-',
        },
        
        {
            title: "Quality",
            dataIndex: "quality",
            key: "quality",
                ...getColumnSearchProps('quality'),
            sorter: (a, b) => a.quality.localeCompare(b.quality),
            sortDirections: ['descend', 'ascend'],
             render: (text) => text ? text : '-',
        },
        {
            title: "Package Type",
            dataIndex: "package_type",
            key: "package_type",
            ...getColumnSearchProps('package_type'),
            sorter: (a, b) => a.package_type.localeCompare(b.package_type),
            sortDirections: ['descend', 'ascend'],
             render: (text) => text ? text : '-',
        },
        {
            title: "Inward Qty",
            dataIndex: "inwardQty",
            key: "inwardQty",
            sorter: (a, b) => a.inwardQty - b.inwardQty,
            sortDirections: ['descend', 'ascend'],

        },
        {
            title: "Price",
            dataIndex: "price",
            key: "price",
            sorter: (a, b) => a.price - b.price,
            sortDirections: ['descend', 'ascend'],
        },
         {
            title: "Inward Amount",
            dataIndex: "inwardAmount",
            key: "inwardAmount",
            sorter: (a, b) => a.inwardAmount - b.inwardAmount,
            sortDirections: ['descend', 'ascend'],
        },
        {
            title: "Bale Qty",
            dataIndex: "baleQty",
            key: "baleQty",
            sorter: (a, b) => a.baleQty - b.baleQty,
            sortDirections: ['descend', 'ascend'],
            render: (value) => Number(Number(value).toFixed(2))
        },
       
        {
            title: "Remaining Qty",
            dataIndex: "remainingQty",
            key: "remainingQty",
            sorter: (a, b) => a.remainingQty - b.remainingQty,
            sortDirections: ['descend', 'ascend'],
            render: (value) => Number(Number(value).toFixed(2))
        },
        {
    title: "Moisture Loss/Gain %",
    key: "moistureLossGain",
    sorter: (a, b) => {
        const aVal =a.reportingType === 'Full'? (-(a.remainingQty / a.inwardQty) * 100): 0;
        const bVal =b.reportingType === 'Full'? (-(b.remainingQty / b.inwardQty) * 100): 0;
        return aVal - bVal;
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => {
        if (record.reportingType !== 'Full') {
            return '-';
        }
        const value =(-(record.remainingQty / record.inwardQty) * 100);
        const isNegative = value < 0;

        return (
            <span style={{color: isNegative ? 'darkred' : 'darkgreen',fontWeight: 'bold',}}>
                {isNegative? Math.abs(value).toFixed(2): value.toFixed(2)}%
            </span>
        );
    },
},
{
    title: "Status",
    key: "status",
    dataIndex: "reportingType",
    filters: [
        { text: 'Open', value: 'open' },
        { text: 'In Progress', value: 'Partial' },
        { text: 'Completed', value: 'Full' },
    ],
    onFilter: (value, record) => {
        if (value === 'open') {
            return (
                record.reportingType === null ||
                record.reportingType === undefined
            );
        }

        return record.reportingType === value;
    },
    render: (reportingType) => {
        let status = 'Open';
        let color = '#faad14';

        if (reportingType === 'Partial') {
            status = 'In Progress';
            color = '#1677ff';
        }

        if (reportingType === 'Full') {
            status = 'Completed';
            color = '#389e0d';
        }

        return (
            <span
                style={{
                    color,
                    fontWeight: 'bold',
                }}
            >
                {status}
            </span>
        );
    },
},
    ]

    const onReset = () => {
        form.resetFields();
        getInwardReport()
      }

    const handleExport = (e: any) => {
    e.preventDefault();

    const currentDate = new Date()
        .toISOString()
        .slice(0, 10)
        .split("-")
        .join("/");

    let rowIndex = 1;

    let exportingColumns: any[] = [];

    exportingColumns.push(
        {
            title: "S.No",
            width: 50,
            render: (text, object, index) => {
                if (index == inwardData.length) {
                    return null;
                } else {
                    return rowIndex++;
                }
            }
        },
        {
            title: "Inward Code",
            dataIndex: "inwardCode",
            render: (text) => text ? text : '-',
        },
        {
            title: "Inward Date",
            dataIndex: "inwardDate",
            render: (text) =>
                text ? moment(text).format('YYYY-MM-DD') : '-',
        },
        {
            title: "Indent Status",
            dataIndex: "indent_status",
            render: (text) => text ? text : '-',
        },
        {
            title: "Inward Type",
            dataIndex: "inwardType",
            render: (text) => text ? text : '-',
        },
        {
            title: "Voucher No",
            dataIndex: "voucherNo",
            render: (text) => text ? text : '-',
        },
        {
            title: "Voucher Date",
            dataIndex: "voucharDate",
            render: (text) =>
                text ? moment(text).format('YYYY-MM-DD') : '-',
        },
        {
            title: "Farmer",
            dataIndex: "supplierName",
            render: (text) => text ? text : '-',
        },
        {
            title: "Product",
            dataIndex: "productName",
            render: (text) => text ? text : '-',
        },
        {
            title: "Quality",
            dataIndex: "quality",
            render: (text) => text ? text : '-',
        },
        {
            title: "Package Type",
            dataIndex: "package_type",
            render: (text) => text ? text : '-',
        },
        {
            title: "Inward Qty",
            dataIndex: "inwardQty",
            render: (value) =>
            value != null ? Number(Number(value).toFixed(2)) : '-',
        },
        {
            title: "Price",
            dataIndex: "price",
            render: (text) =>
                text != null ? Number(text).toFixed(2) : '-',
        },
        {
            title: "Inward Amount",
            dataIndex: "inwardAmount",
            render: (text) =>
                text != null ? Number(text).toFixed(2) : '-',
        },
        {
            title: "Bale Qty",
            dataIndex: "baleQty",
            render: (text) =>
                text != null ? Number(text).toFixed(2) : '-',
        },
        {
            title: "Remaining Qty",
            dataIndex: "remainingQty",
            render: (text) =>
                text != null ? Number(text).toFixed(2) : '-',
        },
        {
            title: "Moisture Loss/Gain %",
            key: "moistureLossGain",
            render: (_, record) => {

                if (record.reportingType !== 'Full') {
                    return '-';
                }

                const value =
                    (-(record.remainingQty / record.inwardQty) * 100);

                const isNegative = value < 0;

                return isNegative
                    ? `${Math.abs(value).toFixed(2)}%`
                    : `${value.toFixed(2)}%`;
            }
        },
        {
            title: "Status",
            dataIndex: "reportingType",
            render: (reportingType) => {

                if (
                    reportingType === null ||
                    reportingType === undefined
                ) {
                    return 'Open';
                }

                if (reportingType === 'Partial') {
                    return 'In Progress';
                }

                if (reportingType === 'Full') {
                    return 'Completed';
                }

                return '-';
            }
        }
    );

    const excel = new Excel();

    excel.addSheet("Inward Report");

    excel.addColumns(exportingColumns);

    excel.addDataSource(inwardData);

    excel.saveAs(`Inward-Report-${currentDate}.xlsx`);
};

    return (
        <div>
            <Card  title={<span style={{ color: 'white' }}>RM Inward Report</span>}
                  style={{ textAlign: 'center' }}
                  headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
                  extra={
                    <Button
        onClick={handleExport}
        icon={<DownloadOutlined />}>Get Excel</Button>
                  }>
        <Form form={form} layout='vertical' onFinish={getInwardReport}>
            <Row gutter={16}>
                <Col span={6}>
                    <Form.Item label="Inward No" name='inwardNo'>
                        <Select placeholder='Select Inward No' showSearch
      optionFilterProp="children" allowClear>
                            {inwardNo && inwardNo.map((item:any)=><Option value={item.inwardId}>{item.inwardNo}</Option>)}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item label="Inward Type" name='inwardType'>
                        <Select placeholder='Select Inward Type' showSearch
      optionFilterProp="children" allowClear>
                            {inwardType && inwardType.map((item:any)=><Option value={item.inwardType}>{item.inwardType}</Option>)}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6}>  
                    <Form.Item label="Farmer" name='supplierId'>
                        <Select placeholder='Select Farmer' showSearch
      optionFilterProp="children" allowClear>
                            {supplierData && supplierData.map((item:any)=><Option value={item.supplierId}>{item.name}</Option>)}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6}>

                    <Form.Item label="Product" name='productId'>
                        <Select placeholder='Select Product' showSearch
      optionFilterProp="children" allowClear>
                            {productsData && productsData.map((item:any)=><Option value={item.productId}>{item.productName}</Option>)}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item label="Voucher No" name='voucherNo'>
                        <Select placeholder='Select Voucher No' showSearch
      optionFilterProp="children" allowClear>
                            {voucherNo && voucherNo.map((item:any)=><Option value={item.voucherNo}>{item.voucherNo}</Option>)}
                        </Select>
                    </Form.Item>
                </Col>
                 <Col >
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Col>

          <Col >
            <Button danger onClick={onReset}>
              Reset
            </Button>
          </Col>
            </Row>
        </Form>
            <Table
                dataSource={inwardData}
                columns={Columns}
            />
            </Card>
        </div>
    )
}

export default InwardReport